import React from "react";
import { observer } from "mobx-react";

import ErrorIcon from "@mui/icons-material/Error";

import CircularProgress from "@mui/material/CircularProgress";

import { styled } from "@mui/material";

const LegendRow = styled("div")({
  display: "flex",
  flexDirection: "row",
  marginBottom: 2,
});
const LegendImage = styled("div")({ marginRight: 10 });
const UnitWrapper = styled("div")({ marginLeft: 30, marginBottom: 10 });

function Legend({
  map,
  view,
  LayerStore,
  layer = null,
  // legendInfo,
  // error,
  // loading,
  nls = {
    title: "Legende",
    loadingError: "Beim Laden der Legende ist ein Fehler aufgetreten",
    noData:
      "Keine Legenden Daten zu dem aktuellen Layer verfügbar oder kein Layer ausgewählt",
  },
  style,
  CommunicationStore,
}) {
  const legendInfo = layer?.legendInfo;
  const error = layer?.legendState === "error";
  const loading = layer?.legendState === "loading" && !legendInfo;

  const message = CommunicationStore.getMessagesToID({
    toId: "shownLayers",
  })?.message;

  const getLayerUnits = (message) => {
    const metaData =
      message?.layerInfos[message.layerInfos.length - 1]?.metaData;
    return metaData?.units ? `[${metaData.units}]` : "";
  };
  return (
    <>
      {loading && <CircularProgress />}
      {!loading && error && (
        <div>
          <ErrorIcon style={{ color: "red" }} />
          <div>{nls.loadingError}</div>
        </div>
      )}
      {!loading && !error && !legendInfo && nls.noData}
      {!loading && !error && legendInfo && (
        <UnitWrapper>{getLayerUnits(message)}</UnitWrapper>
      )}
      {!loading &&
        !error &&
        legendInfo &&
        legendInfo.legend.map(
          ({ label, height, width, imageData, contentType }, i) => {
            return (
              <LegendRow key={`${label}-${i}`}>
                <LegendImage>
                  <img
                    alt={label}
                    src={`data:${contentType};base64,${imageData}`}
                    height={height}
                    width={width}
                  />
                </LegendImage>
                <div>{label}</div>
              </LegendRow>
            );
          }
        )}
    </>
  );
}

export default observer(Legend);
